import { Component, ViewChild, ElementRef } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';
declare var $: any;

@Component({
  selector: 'ct-textarea',
  templateUrl: './ct-textarea.component.html',
  styleUrls: ['./ct-textarea.component.css']
})


export class CtTextareaComponent extends InputBaseComponent {
  @ViewChild('el') formControl: ElementRef;
  public maxLength: any;
  public rows: number;
  public htmlNewLineScape: boolean;

  constructor() {
    super();
  }

  getValue(): string {
    let val = super.getValue();

    if (this.htmlNewLineScape && val)
      return val.replace(/\n/g, '<br>');
    return val;
  }
  
  getMaxLength() { return this.maxLength };
  getRows() { return this.rows };
  getHtmlNewLineScape() { return this.htmlNewLineScape };

  setMaxLength(maxLength: any) { this.maxLength = maxLength }
  setRows(rows: number) { this.rows = rows }
  setHtmlNewLineScape(htmlNewLineScape: boolean) { this.htmlNewLineScape = htmlNewLineScape }

  getJSON() {
    return '{"id":"text","ctType":"CtTextArea","controlProperties":{"hidden":false,"labelValue":"","rows":"6","maxLength":4000,"htmlNewLineScape":false,"readOnly":false,"value":"","required":false,"requiredMessage":"","placeholder":"Escriba su mensaje aquí...","tooltipMessage":""},"controlActions":[],"models":[]}';
  }
}

